/**
 * TranscriptView
 *
 * Chat-style transcript with agent bubbles on the left and caller on the right.
 */

import { cn } from '@/lib/utils';
import type { ITranscriptViewProps } from '@/@types/voiceAgents';

function formatTimestamp(ms: number): string {
  const totalSec = Math.round(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${String(sec).padStart(2, '0')}`;
}

export function TranscriptView({ segments }: ITranscriptViewProps) {
  if (segments.length === 0) {
    return (
      <div className="flex items-center justify-center py-16 text-muted-foreground text-sm">
        No transcript available
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 p-4">
      {segments.map((segment, _index) => {
        const isAgent = segment.speaker === 'agent';
        return (
          <div
            key={`${segment.speaker}-${segment.startMs}`}
            className={cn('flex', isAgent ? 'justify-start' : 'justify-end')}
          >
            <div
              className={cn(
                'max-w-[75%] rounded-lg px-3 py-2 text-sm',
                isAgent ? 'bg-muted text-foreground' : 'bg-primary text-primary-foreground'
              )}
            >
              <p className="text-xs font-medium mb-0.5 opacity-70">
                {isAgent ? 'Agent' : 'Caller'}
              </p>
              <p>{segment.text}</p>
              <span className="text-[10px] opacity-60 mt-1 block text-right">
                {formatTimestamp(segment.startMs)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
